// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2k-6";
export var headerCell = "_2k-2";
export var rowWrapper = "_2k-4";
export var stickyAggregationCell = "_2k-a";
export var stickyAggregationRow = "_2k-7";
export var stickyColumnCell = "_2k-9";
export var stickyColumnHeaderCell = "_2k-8";
export var table = "_2k-1";
export var virtualRowWrapper = "_2k-5";
export var virtualTableContainer = "_2k-0";
export var white = "_2k-3";